var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSquareContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.50817V13.4915C18.3333 15.8332 17.2583 17.4415 15.3667 18.0498C14.8167 18.2415 14.1833 18.3332 13.4917 18.3332H6.50833C5.81666 18.3332 5.18333 18.2415 4.63333 18.0498C2.74166 17.4415 1.66666 15.8332 1.66666 13.4915V6.50817C1.66666 3.47484 3.475 1.6665 6.50833 1.6665H13.4917C16.525 1.6665 18.3333 3.47484 18.3333 6.50817Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3667 18.0499C14.8167 18.2416 14.1833 18.3333 13.4917 18.3333H6.50833C5.81666 18.3333 5.18333 18.2416 4.63333 18.0499C4.925 15.8499 7.225 14.1416 10 14.1416C12.775 14.1416 15.075 15.8499 15.3667 18.0499Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 9.64985C12.9833 11.2999 11.65 12.6415 10 12.6415C8.35 12.6415 7.01666 11.2999 7.01666 9.64985C7.01666 7.99985 8.35 6.6665 10 6.6665C11.65 6.6665 12.9833 7.99985 12.9833 9.64985Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquareContained);
export default __webpack_public_path__ + "static/media/user-square-contained.712a20539b89b8dfc65c19ca98d2b2c7.svg";
export { ForwardRef as ReactComponent };